var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"15px"}},[_c('table-other-models',{attrs:{"car":_vm.car,"id":_vm.carId,"iframe":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }